<template>
  <b-card class="search-result-item">
    <div class="search-result-icon-col">
      <template v-if="isChild">
        <img class="menu-icon" :src="'static/icons/icon-Aula_calendar_child.svg'" />
      </template>
      <i v-else class="icon-Aula_calendar" />
    </div>
    <div class="search-result-text-col">
      <div class="card-header-text">
        <keyword-highlight :queries="searchString">
          {{ eventItem.title }}
        </keyword-highlight>
      </div>
      <ul class="card-text list-unstyled">
        <li v-if="eventItem.description != ''">
          {{ $getText('SEARCH_DESC_LABEL') }}:
          <span v-html="highlightText(eventItem.description)" />
        </li>
        <template v-if="eventItem.type === eventTypes.PRESENCE_HOLIDAY">
          <li>{{ formattedEventLongDate(eventItem.startDateTime, true) }}</li>
          <li>{{ formattedEventLongDate(eventItem.endDateTime, true) }}</li>
        </template>
        <template v-else>
          <li>
            {{ formattedEventLongDate(eventItem.startDateTime) }}
            {{ formattedEventTime(eventItem.startDateTime) }}
          </li>
          <li>
            {{ formattedEventLongDate(eventItem.endDateTime) }}
            {{ formattedEventTime(eventItem.endDateTime) }}
          </li>
        </template>
        <li v-if="eventItem.location">
          {{ eventItem.location }}
        </li>
        <li v-if="eventItem.type !== eventTypes.PRESENCE_HOLIDAY">
          {{ $getText('SEARCH_CREATOR_BY_LABEL') }}:
          <keyword-highlight :queries="searchString">
            {{ eventItem.creatorAulaName }}
          </keyword-highlight>
        </li>
      </ul>
    </div>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import KeywordHighlight from 'vue-text-highlight';
import { types } from '../../store/types/types';
import moment from 'moment-timezone';
import { eventTypeEnum } from '../../../shared/enums/eventTypeEnum';
import { htmlUtil } from '../../../shared/utils/htmlUtil';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';

export default {
  props: {
    eventItem: { type: Object, default: () => {} },
    searchString: { type: String, default: '' },
    parentSource: { type: String, default: null },
    validGroupModules: { type: Array, default: () => [] },
    numberOfMenuItems: { type: Number, default: 4 },
    isChild: { type: Boolean, default: false },
  },
  data: function () {
    return {
      moment: moment,
      eventTypes: eventTypeEnum,
    };
  },
  methods: {
    ...mapActions({
      setEventSelectedFromSearch: types.SET_EVENT_SELECTED_FROM_SEARCH,
      resetActiveGroup: types.RESET_ACTIVE_GROUP,
    }),
    highlightText(text) {
      return htmlUtil.highlightKeyword(text, this.searchString);
    },
    formattedEventLongDate(dateTime, utc = false) {
      return DateTimeUtil.longDate(dateTime, false, false, utc);
    },
    formattedEventTime(dateTime) {
      return DateTimeUtil.formatDate(dateTime, 'HH:mm');
    },
  },
  components: {
    KeywordHighlight,
  },
};
</script>

<style scoped lang="scss">
.card-text {
  text-transform: capitalize;
}
</style>
